import { SelectionItem, GroupedItem } from '@utils';
import { create } from 'zustand'
import { useLanguage } from '../context/LanguageContext'


const contextGrouped: GroupedItem[] = [
  {
    id: 'education-formation',
    name: 'meetingContexts.education-formation',
    items: [
      { id: 'educatif', name: 'meetingContexts.educatif' },
      { id: 'formation', name: 'meetingContexts.formation' },
      { id: 'etude', name: 'meetingContexts.etude' },
    ],
  },
  {
    id: 'event-pro',
    name: 'meetingContexts.event-pro',
    items: [
      { id: 'event', name: 'meetingContexts.event' },
      { id: 'event-pro', name: 'meetingContexts.event-pro-item' },
      { id: 'networking', name: 'meetingContexts.networking' },
      { id: 'etude-client', name: 'meetingContexts.etude-client' },
    ],
  },
  {
    id: 'sport-hobbies',
    name: 'meetingContexts.sport-hobbies',
    items: [
      { id: 'sport', name: 'meetingContexts.sportif' },
      { id: 'loisir', name: 'meetingContexts.loisir' },
      { id: 'festival', name: 'meetingContexts.festival' },
      { id: 'artistique', name: 'meetingContexts.artistique' },
    ],
  },
  {
    id: 'voyage-discovery',
    name: 'meetingContexts.voyage-discovery',
    items: [
      { id: 'voyage', name: 'meetingContexts.voyage' },
      { id: 'naturel-voyage', name: 'meetingContexts.naturel' },
    ],
  },
  {
    id: 'relations-rencontres',
    name: 'meetingContexts.relations-rencontres',
    items: [
      { id: 'mariage', name: 'meetingContexts.mariage' },
      { id: 'rencontre-sociale', name: 'meetingContexts.rencontre-sociale' },
      { id: 'rencontre-famille', name: 'meetingContexts.rencontre-famille' },
      { id: 'rencontre-benevole', name: 'meetingContexts.rencontre-benevole' },
      { id: 'famille-proche', name: 'meetingContexts.famille-proche' },
    ],
  },
  {
    id: 'event-online',
    name: 'meetingContexts.event-online',
    items: [
      { id: 'eventSpecific', name: 'meetingContexts.eventSpecific' },
    ],
  },
]

interface ContextStore {
  contexts: GroupedItem[]
  getAllContexts: () => SelectionItem[]
  getContextsByGroup: (groupId: string) => SelectionItem[]
}

export const useContextStore = create<ContextStore>((set, get) => ({
  contexts: contextGrouped,
  getAllContexts: () => {
    // Flatten all items and remove duplicates by id
    const all = get().contexts.flatMap(group => group.items)
    const unique: { [id: string]: SelectionItem } = {}
    all.forEach(item => { unique[item.id] = item })
    return Object.values(unique)
  },
  getContextsByGroup: (groupId) => {
    const group = get().contexts.find(g => g.id === groupId)
    return group ? group.items : []
  },
}))

export const useTranslatedContextStore = () => {
  const { t } = useLanguage()
  const store = useContextStore()

  const translateGroup = (group: GroupedItem): GroupedItem => ({
    ...group,
    name: t(group.name),
    description: group.description ? t(group.description) : undefined,
    items: group.items.map(item => ({ ...item, name: t(item.name) })),
  })

  return {
    contexts: store.contexts.map(translateGroup),
    getAllContexts: () => store.getAllContexts().map(item => ({ ...item, name: t(item.name) })),
    getContextsByGroup: (groupId: string) => store.getContextsByGroup(groupId).map(item => ({ ...item, name: t(item.name) })),
  }
}